var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FEE5F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9996 17.0043C18.3411 17.0043 17.004 18.3543 17.004 20C17.004 21.6457 18.354 22.9957 19.9996 22.9957C21.6452 22.9957 22.9952 21.6457 22.9952 20C22.9952 18.3543 21.6452 17.0043 19.9996 17.0043ZM28.9992 20C28.9992 18.7529 28.9992 17.5314 28.9349 16.2843C28.8706 14.8443 28.5364 13.5586 27.4821 12.5171C26.4279 11.4629 25.1551 11.1286 23.7151 11.0643C22.4681 11 21.2467 11 19.9996 11C18.7525 11 17.5311 11 16.284 11.0643C14.8441 11.1286 13.5585 11.4629 12.5171 12.5171C11.4628 13.5714 11.1286 14.8443 11.0643 16.2843C11 17.5314 11 18.7529 11 20C11 21.2471 11 22.4686 11.0643 23.7157C11.1286 25.1557 11.4628 26.4414 12.5171 27.4829C13.5713 28.5371 14.8441 28.8714 16.284 28.9357C17.5311 29 18.7525 29 19.9996 29C21.2467 29 22.4681 29 23.7151 28.9357C25.1551 28.8714 26.4407 28.5371 27.4821 27.4829C28.5364 26.4286 28.8706 25.1557 28.9349 23.7157C29.0121 22.4814 28.9992 21.2471 28.9992 20ZM19.9996 24.6157C17.4411 24.6157 15.3841 22.5586 15.3841 20C15.3841 17.4414 17.4411 15.3843 19.9996 15.3843C22.5581 15.3843 24.6151 17.4414 24.6151 20C24.6151 22.5586 22.5581 24.6157 19.9996 24.6157ZM24.808 16.2714C24.2166 16.2714 23.728 15.7957 23.728 15.1914C23.728 14.5871 24.2037 14.1114 24.808 14.1114C25.4122 14.1114 25.8879 14.5871 25.8879 15.1914C25.8912 15.3323 25.8655 15.4723 25.8124 15.6027C25.7593 15.7332 25.68 15.8514 25.5793 15.95C25.4808 16.0506 25.3626 16.13 25.2321 16.183C25.1016 16.2361 24.9616 16.2618 24.8208 16.2586L24.808 16.2714Z",
    fill: "#FF3093"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.4c0b91100ed1de5a789e93aa5cda6373.svg";
export { ForwardRef as ReactComponent };